export default {
    install(Vue, options){
        Vue.prototype.$encryptData = (data)=>{
            return Vue.prototype.CryptoJS.AES.encrypt(
                JSON.stringify(data),
                process.env.VUE_APP_IDENTIFIER
            ).toString()
        }
        Vue.prototype.$decryptData = (data, parseJSON = true)=>{
            let decryptData = Vue.prototype.CryptoJS.AES.decrypt(data, process.env.VUE_APP_IDENTIFIER).toString(Vue.prototype.CryptoJS.enc.Utf8)
            return parseJSON ? JSON.parse(decryptData) : decryptData; 
        }
        // Vue.prototype.$anotherFunction = (data)=>{
        // 
        // }
    }
}